import React from 'react';

export default function KPICard({ title, value, sub, note, icon, color = '#6366f1', loading }) {
  return (
    <div style={{ ...styles.card, borderTop: `3px solid ${color}` }}>
      <div style={styles.top}>
        <div>
          <p style={styles.title}>{title}</p>
          {loading ? (
            <div style={styles.skeleton} />
          ) : (
            <p style={{ ...styles.value, color }}>{value}</p>
          )}
          {sub && !loading && <p style={styles.sub}>{sub}</p>}
          {note && !loading && <p style={styles.note}>{note}</p>}
        </div>
        {icon && <span style={{ ...styles.icon, background: color + '20', color }}>{icon}</span>}
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: '#fff',
    borderRadius: '0.75rem',
    padding: '1.25rem 1.5rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    flex: 1,
    minWidth: '180px',
  },
  top: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
  title: { fontSize: '0.8rem', fontWeight: '600', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', margin: '0 0 0.4rem 0' },
  value: { fontSize: '1.75rem', fontWeight: '700', margin: '0 0 0.25rem 0' },
  sub: { fontSize: '0.8rem', color: '#94a3b8', margin: 0 },
  note: { fontSize: '0.7rem', color: '#cbd5e1', fontStyle: 'italic', margin: '0.3rem 0 0 0', lineHeight: 1.3 },
  icon: { width: '2.75rem', height: '2.75rem', borderRadius: '0.625rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.25rem', flexShrink: 0 },
  skeleton: { height: '2rem', width: '6rem', background: '#e2e8f0', borderRadius: '0.375rem', marginBottom: '0.25rem', animation: 'pulse 1.5s ease-in-out infinite' },
};
